import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const CreatedSuccessfull = ({ onSucess }) => {
  const handleOkayClick = () => {
    onSucess();
  };

  return (
    <Dialog
      open={true}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
          textAlign: "center",
          boxShadow: "0px 8px 24px rgba(0,0,0,0.1)",
        },
      }}
    >
      <DialogContent>
        <Box
          className="d-flex flex-column align-items-center justify-content-center"
          sx={{ py: 3 }}
        >
          <CheckCircleOutlineIcon
            sx={{
              fontSize: 80,
              color: "#4caf50",
              mb: 2,
              animation: "pop 0.5s ease",
              "@keyframes pop": {
                "0%": { transform: "scale(0.8)", opacity: 0 },
                "100%": { transform: "scale(1)", opacity: 1 },
              },
            }}
          />

          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "#333",
              mb: 1,
            }}
          >
            Online Session Created Successfully!
          </Typography>

          <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
            Your live class is now ready. You can start whenever you’re ready.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button
          variant="contained"
          onClick={handleOkayClick}
          sx={{
            backgroundColor: "#FF6B00",
            fontWeight: 600,
            textTransform: "none",
            px: 4,
            py: 1,
            borderRadius: 2,
            "&:hover": {
              backgroundColor: "#e55f00",
            },
          }}
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatedSuccessfull;
